import React from "react";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import TheBook from "@/components/landing/TheBook";
import Cohort from "@/components/landing/Cohort";
import WhatYouGet from "@/components/landing/WhatYouGet";
import WhosBehind from "@/components/landing/WhosBehind";
import ApplicationForm from "@/components/landing/ApplicationForm";
import Footer from "@/components/landing/Footer";

export default function LandingPage() {
  return (
    <main data-testid="landing-page" className="relative bg-cream text-ink overflow-x-hidden font-body">
      <Header />
      <Hero />
      <TheBook />
      <Cohort />
      <WhatYouGet />
      <WhosBehind />
      <ApplicationForm />
      <Footer />
    </main>
  );
}
